function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { ActionListItem } from '../ActionListItem';
import moduleStyles from '@dtsl/css-action-list/dist/index.module.css';
function ActionListSection(props) {
  let {
    options
  } = props;
  let ops = options.map((option, index) => {
    let _options = option.items.map(item => /*#__PURE__*/React.createElement(ActionListItem, _extends({
      key: item.id
    }, item)));
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: moduleStyles['sib-action-list__section'],
      role: "list"
    }, /*#__PURE__*/React.createElement("ul", {
      className: moduleStyles['sib-action-list__section-content']
    }, ' ', _options));
  });
  return ops.length ? ops : null;
}
ActionListSection.defaultProps = {
  options: []
};
ActionListSection.propTypes = {
  options: PropTypes.array
};
export default ActionListSection;